import React, { useState } from 'react';

import {
  Button,
  Conditional,
  Cross,
  Icon,
  Loader,
  ModalContent,
  ModalHeader,
  Space,
  Text,
  UploadFile,
  toast,
} from '@cashfree-intl/coherent';

// Styled
import { StyledEditChequeModal } from '../styled';

// Types
import { EditChequeModalProps } from '../types';

// Hooks
import useDocActions from 'hooks/useDocActions';

// Constants
import { CANCELLED_CHEQUE_FILE_SIZE_LIMIT, CHECKLIST } from '../constants';

const EditChequeModal = ({
  onClose,
  accountName,
  chequeDetails,
  handleUploadChange,
  loading,
  disableEdit = false,
}: EditChequeModalProps) => {
  const {previewDoc}=useDocActions()
  const [isViewMode, setIsViewMode] = useState(true);
  const setEditMode = () => setIsViewMode(false)
  const onSubmitClick=() => {
    onClose();
    if (!isViewMode) {
      toast.success(`Cancelled Cheque submitted`);
    }
  }
  return (
    <StyledEditChequeModal open $maxWidth={480} data-testid="edit-cheque-modal">
      <Loader active={loading} loadingText="Uploading" />
      <ModalHeader>
        Cancelled Cheque
        <Cross onClick={onClose} />
      </ModalHeader>
      <ModalContent>
        <Conditional if={isViewMode && !disableEdit}>
          <Space
            justifyContent="flex-end"
            alignItems="center"
            className="mb-2 pointer"
            onClick={setEditMode}
            data-testid="edit-cheque-button"
          >
            <Icon name="edit" className="edit-icon" />
            <Text variant="b14" color="primary">
              Edit
            </Text>
          </Space>
        </Conditional>
        <Text variant="b14" color="bodyLight" className="mb-1">
          Cancelled cheque of {accountName}
        </Text>
        <UploadFile
          type="primary"
          buttonText="Upload"
          checkList={CHECKLIST}
          accept=".png, .jpeg, .pdf"
          onChange={payload => {
            handleUploadChange(payload, 'cheque_selfServe');
          }}
          uploaded={!!chequeDetails?.name && chequeDetails}
          disabled={chequeDetails?.locked}
          sizeLimit={CANCELLED_CHEQUE_FILE_SIZE_LIMIT}
          editable={!isViewMode}
          showPreview={previewDoc(chequeDetails)}
        />
        <Conditional if={!!chequeDetails?.rejectionReasons?.length}>
          <Text variant="b14" color="danger" className="mt-1">
            {chequeDetails?.rejectionReasons?.join(', ')}
          </Text>
        </Conditional>
        <Space justifyContent="center" className="mt-5">
          <Button
            primary
            onClick={onSubmitClick}
            disabled={!chequeDetails?.name}
            data-testid="submit-button"
          >
            {isViewMode ? 'Okay ,Got it.' : 'Submit'}
          </Button>
        </Space>
      </ModalContent>
    </StyledEditChequeModal>
  );
};

export default EditChequeModal;
